export default class Form {
  constructor({ elm, app }) {
    this.app = app;
    this.elm = elm;
  }
}
